import { Box, Typography } from '@mui/material';
import { Control, Controller } from 'react-hook-form';

import CustomDatePicker from 'components/CustomDatePicker';
import CustomInput from 'components/CustomInput';
import CustomPhoneInput from 'components/CustomPhoneInput';

import { getPhoneFromAddress } from 'utils/formatters';
import { NewCustomerFormData } from 'validation/newCustomerSchema';

interface PersonalInformationSectionProps {
  control: Control<NewCustomerFormData>;
}

const PersonalInformationSection = ({ control }: PersonalInformationSectionProps) => (
  <Box mt={5} sx={{ flex: 1 }}>
    <Typography variant="h6" mb={2}>Personal Information</Typography>
    <Box display="flex" flexDirection="column" gap={2}>
      <Controller
        name="firstName"
        control={control}
        render={({ field, fieldState }) => (
          <CustomInput
            {...field}
            size="small"
            label="First Name"
            required
            fullWidth
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      />

      <Controller
        name="lastName"
        control={control}
        render={({ field, fieldState }) => (
          <CustomInput
            {...field}
            size="small"
            required
            label="Last Name"
            fullWidth
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      />

      <Controller
        name="email"
        control={control}
        render={({ field, fieldState }) => (
          <CustomInput
            {...field}
            size="small"
            label="Email"
            fullWidth
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      />

      <Controller
        name="phone"
        control={control}
        render={({ field, fieldState }) => (
          <CustomPhoneInput
            {...field}
            phoneNumber={getPhoneFromAddress()}
            required
            fullWidth
            label="Phone number"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            onChange={(value) => field.onChange(value.phoneNumber)}
          />
        )}
      />

      <Controller
        name="dateOfBirth"
        control={control}
        render={({ field, fieldState }) => (
          <CustomDatePicker
            {...field}
            size="small"
            fullWidth
            label="Date of Birth"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            value={field.value ? new Date(field.value) : null}
            required
            onChange={(date) => field.onChange(date)}
          />
        )}
      />
    </Box>
  </Box>
);

export default PersonalInformationSection;
